//Import required modules
import React from 'react';
import * as d3 from 'd3';
import PropTypes from 'prop-types'

//Import Data
const centNumbers = d3.range(1,1000)

const Bar = (props, {store}) =>
{
let userWindow = store.getState().userWindow;
let circleCount = userWindow.circleCount
let vizData = store.getState().userPalette.flat()
let rx = 5;
let ry = 5;
// set the dimensions and margins of the graph
let divWidth = userWindow.vizHolderWidth
let margin = {top: 2, right: 10, bottom: 10, left: 10},
              width = divWidth - margin.left - margin.right,
              height = (vizData.length>circleCount?202:270) - margin.top - margin.bottom;

let barData = centNumbers.slice(0, vizData.length)

// Add X axis
let x = d3.scaleBand()
            .range([0, width])
            .domain(d3.range(vizData.length))
            .paddingInner(0.05);
// Y axis
let y = d3.scaleLinear()
            .domain([0,
                     d3.max(barData)])
            .range([height,0]);

return (
    <svg width={width + margin.left + margin.right}
         height={height + margin.top + margin.bottom}
         id='myVizBAR'>
             <g transform={`translate(${margin.left},${margin.top})`}>
                 {vizData.map((d,i) =>
                    <rect 
                        key={i}
                        x={x(i)}
                        rx={rx}
                        ry={ry}
                        y={y(centNumbers[i])}
                        width={x.bandwidth()}
                        height={height-y(centNumbers[i])}
                        fill={d.color}>
                    </rect>)}
             </g>
    </svg>
)
}

Bar.contextTypes = {
    store: PropTypes.object
}
  

export default Bar;